// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Op-z","breadcrumbForward":"Pp-z","breadcrumbBack":"Qp-z","selected":"Rp-z"};